export default __webpack_public_path__ + "static/media/lead-time.73ee1b1b.png";